import { render, staticRenderFns } from "./ticket-details.vue?vue&type=template&id=e980509e&scoped=true&"
import script from "./ticket-details.vue?vue&type=script&lang=js&"
export * from "./ticket-details.vue?vue&type=script&lang=js&"
import style0 from "./ticket-details.vue?vue&type=style&index=0&id=e980509e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e980509e",
  null
  
)

export default component.exports